<template>
  <GenericDataView
    v-slot="{id, loading, isUpdateForm}"
    title="Service Level Objectives"
    local-storage-key="serviceLevelObjectives"
    :state="serviceLevelObjectives"
    :read="serviceLevelObjectivesStore.readServiceLevelObjectives"
    :set="serviceLevelObjectivesStore.setServiceLevelObjectives"
    :delete="serviceLevelObjectivesStore.deleteServiceLevelObjective"
    :cols-map="colsMap"
    :cached="cached"
    @cached="cached = true"
  >
    <SlosFormController :id="id" :loading="loading" :is-update-form="isUpdateForm" />
  </GenericDataView>
</template>
<script setup lang="ts">
import {ServiceLevelObjective} from '@/stores/userManagement/userManagement';

const serviceLevelObjectivesStore = useServiceLevelObjectivesStore();
const {serviceLevelObjectives} = storeToRefs(serviceLevelObjectivesStore);
const cached = ref(false);

const colsMap = readonly<{[key: string]: keyof ServiceLevelObjective}>({
  'Objective Name': 'name',
  'Objective Type': 'measurement_type',
  'Visible for Customer': 'customer_visibility',
});
</script>
